import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const firstHalf = categories.slice(0, 7);
  const secondHalf = categories.slice(7);

  return (
    <footer className="bg-primary-800 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            {/* Brand Column */}
            <div>
              <Link to="/" className="font-heading text-2xl font-bold text-white inline-block mb-4">
                GTBuy<span className="text-accent-400">.</span>
              </Link>
              <p className="text-background-200/80 text-sm leading-relaxed mb-4 max-w-xs">
                The ultimate spreadsheet-based order tracking and automation system for smarter shopping workflows.
              </p>
              <p className="font-heading text-lg text-white/90 italic">
                Shop Smarter.<br />Ship Faster.
              </p>
            </div>

            {/* Categories Column 1 */}
            <div>
              <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Categories</h4>
              <ul className="space-y-2.5">
                {firstHalf.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-200/70 hover:text-white transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Categories Column 2 */}
            <div>
              <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">More Categories</h4>
              <ul className="space-y-2.5">
                {secondHalf.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-200/70 hover:text-white transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Guides & Links */}
            <div>
              <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Guides</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/shopping-guide" className="text-sm text-background-200/70 hover:text-white transition-colors cursor-pointer">
                    Shopping Guide
                  </Link>
                </li>
                <li>
                  <Link to="/gtbuy-spreadsheet-complete-guide" className="text-sm text-background-200/70 hover:text-white transition-colors cursor-pointer">
                    GTBuy Complete Guide
                  </Link>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-200/70 hover:text-white transition-colors cursor-pointer"
                  >
                    Kaspreadsheet Store
                  </a>
                </li>
                <li>
                  <Link to="/" className="text-sm text-background-200/70 hover:text-white transition-colors cursor-pointer">
                    Home
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-background-200/20 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-200/50">
              &copy; {new Date().getFullYear()} gtbuyspreadsheet.team. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/" className="text-xs text-background-200/50 hover:text-white transition-colors cursor-pointer">Privacy Policy</Link>
              <Link to="/" className="text-xs text-background-200/50 hover:text-white transition-colors cursor-pointer">Terms</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}